module.exports = __webpack_public_path__ + "img/layout-card.10833484.svg";